export default "__VITE_PUBLIC_ASSET__a8db6c2e__"